import { render, staticRenderFns } from "./ParticularDefeated.vue?vue&type=template&id=aeabb5ec&scoped=true&"
import script from "./ParticularDefeated.vue?vue&type=script&lang=js&"
export * from "./ParticularDefeated.vue?vue&type=script&lang=js&"
import style0 from "./ParticularDefeated.vue?vue&type=style&index=0&id=aeabb5ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeabb5ec",
  null
  
)

export default component.exports